import { render, staticRenderFns } from "./QuickSettingsFloating.vue?vue&type=template&id=4f4e9509&scoped=true"
import script from "./QuickSettingsFloating.vue?vue&type=script&lang=js"
export * from "./QuickSettingsFloating.vue?vue&type=script&lang=js"
import style0 from "./QuickSettingsFloating.vue?vue&type=style&index=0&id=4f4e9509&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4e9509",
  null
  
)

export default component.exports